const e = {
  s0289cd9e4bcf84c5: "Volume sonore",
  s061cc20e3432dead: "Pause",
  s0622a6e6cb77254b: "Transcription",
  s080d032fc1b87b3f: "Descriptions audio",
  s08b06007b5567108: "de",
  s08e6bd98452e6bb9: "Audio",
  s1b4a36fce2456660: "Famille de police",
  s1fa5be5a4f5d0f04: "Informel",
  s23537b5c9e7af982: "Sous-titres",
  s24221a89168e9d21: "Taille de police",
  s255857544a9d5ec0: "Réinitialiser",
  s25a858f0257e2879: "Menu des sous-titres",
  s2df075aface0dab8: "Partager",
  s2f5d5d2d1f92de26: "Télécharger la vidéo",
  s302cbb19bf9a174a: "Désactivé",
  s308604b3ae13fbb5: "Lecture",
  s344ea8f4939cdc98: "Couleur",
  s3687049d1af562c4: "Copier",
  s36b979e4de5152b3: "Lien copié",
  s37a9e8aec5713460: "Plus",
  s3ca1bdfa8785f808: "Sans Serif proportionnelle",
  s41faaf3b4e182cc6: "L’âge doit être vérifié pour accéder à ce contenu.",
  s49f06dca0feeb2f3: "Uniforme",
  s4b023aafbd8d5ac8: "Partager cette vidéo sur",
  s4b10acae683d2978: "Plein écran",
  s500caa88d20458d3: "Vous n’êtes pas autorisé à accéder à ce contenu",
  s5267658ceae3230f: "Partager cette vidéo",
  s5c5db15dfc3a5376: "Vitesse de lecture",
  s5e3cb80d43a34044: "Noir",
  s5e8250fb85d64c23: "Fermer",
  s669b18c6d2d9c95b: "Aucune",
  s66d852e3c020e79e: "Opaque",
  s6a3bf589eaf72169: "Serif non proportionnelle",
  s6baf78886c99db89: "Jaune",
  s6f59e9b81c5a47e0: "Ombre portée",
  s711d047dea682c1a: "Piste audio",
  s7d148a08796094d2: "Erreur de lecture",
  s81a19821f3e4a3d2: "Relecture",
  s827bc70ebcb7bbc6: "Sans Serif non proportionnelle",
  s85186a61e0d55bac: "Vidéo",
  s889413eb7198ea01: "option pour désactiver les sous-titres",
  s8e408592fd4ae43a: "Style du bord du texte",
  s8e985aeeca6a8166: "Blanc",
  s8eafb22ebdc7e668: "Magenta",
  s9559a51a63cbb5fd: "Petites capitales",
  s95bc8722b2708f8b: "En pause",
  s973b83fb67a5865d: "Télécharger la transcription",
  s9b3c2f9cc32d565a: "Cyan",
  s9c356016f81585f6: "Couleur de l’arrière-plan",
  s9d8b8aa2b404c2c8: "Paramètres",
  s9fbd543f2179c1ec: "Menu Audio",
  sa000eaf7092088c3: "Barre de progression",
  sa6f2645578b2d2bc: "Année",
  sa9011e79e3ca2d18: "Enfoncé",
  saf9b398ab363c174: "Saisissez votre date de naissance",
  sb3d4f79d9d8b71e5: "Envoyer",
  sb47daaf9e1c4a905: "Mois",
  sb9f16a5f9c29f41e: "Nous sommes désolés, mais une erreur s’est produite.",
  sba64d8954d027206: "Opacité",
  sc07837c309cc699b: "Activer le son",
  scd105819b5a10243: "Lecture",
  sce836928a17d96ed: "Couleur du texte",
  scf00d78fd5953f1c: "Vert",
  sd1246235faaa3191: "Une restriction d’âge est appliquée en raison de thèmes réservés aux adultes ou d’exigences juridiques destinées à protéger les jeunes publics.",
  sd3386a2ef42e80b9: "Télécharger",
  sd8d4b1b613d28990: "Cursive",
  sdb02f53e62c1da05: "Déclenché",
  sdb73788b3c975f16: "Automatique",
  se0955919920ee87d: "Jour",
  se0f67eae944f8f94: "Couper le son",
  se73c59cc10f48c12: "Réseaux sociaux",
  secf3d3a7c1693e2d: "Bleu",
  sed31876562d94652: "Paramètres des sous-titres",
  sf113fa256db9617b: "Terminé(e)s",
  sf675f879b1c892c6: "Qualité",
  sfc24a457269b13d4: "Curseur de volume",
  sfcb817633bf70e1b: "Serif proportionnelle"
};
export {
  e as templates
};
